import { Route, Routes } from 'react-router-dom'

import Detail from './screens/Detail'
import Overview from './screens/Overview'

const ProjectsRoutes = () => (
  <Routes>
    <Route path="/" element={<Overview />} />
    <Route path="/:taskListId/*" element={<Detail />} />
  </Routes>
)

export default ProjectsRoutes
